/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};

Greenmile.Task.RelatedInfo.Task = {

    removeLinkedTaskFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode.parentNode;

        if (lineItem.className === 'controls') {
            lineItem = el.parentNode.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedTaskFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.anotherTask.nodes;
        var data = Monet.Session.Task.lastLinkForm.anotherTask.data;
        var ids = Monet.Session.Task.lastLinkForm.anotherTask.ids;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.anotherTask.splice(index, 1);
        }

    },

    createFullTaskInfo: function (data) {

        Monet.Session.Task.lastLinkForm.anotherTask.nodes = [];
        Monet.Session.Task.lastLinkForm.anotherTask.data = [];
        Monet.Session.Task.lastLinkForm.anotherTask.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('anotherTask')) {
                this.createTaskIdNode(data[i]);
            }

        }

    },

    createTaskIdNode: function (data) {

        // Create element nodes
        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var input = document.createElement('input');
        var inputStatus = document.createElement('input');
        var inputLinked = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        var value = data.anotherTask.title || data.anotherTask.description;

        divContainer.id = "task_" + data.anotherTask.id;
        divContainer.className = "item_lookuplist_task_" + data.anotherTask.id;

        divTitle.className = "title_item_added";
        divTitle.innerHTML = value;

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";

        divClear.style.clear = "both";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteTask = () => {

                    App.Views.Task.showLoadingElement(this);
                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {

                            App.Views.Task.hideLoad();

                            scope.removeLinkedTaskFromList(e.target);
                            scope.removeLinkedTaskFromData(e.target);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.ANOTHER_TASK
                                );
                        };
                    }(e)));
                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteTask);
            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = "taskLinkeds[" + data.anotherTask.id + "].when";
        linkedTaskWhen.name = "taskLinkeds[" + data.anotherTask.id + "].when";
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = "hidden";
        input.name = "taskLinkeds[" + data.anotherTask.id + "].anotherTask.id";
        input.id = "taskLinkeds[" + data.anotherTask.id + "].anotherTask.id";
        input.className = "modelAttribute";
        input.value = data.anotherTask.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.anotherTask.id + '].status';
        inputStatus.id = 'taskLinkeds' + data.anotherTask.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.anotherTask.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.anotherTask.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.anotherTask.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.anotherTask.data.push(data);
        Monet.Session.Task.lastLinkForm.anotherTask.ids.push(input);
    }
};